export const parseToArray = (value) => {
  return value.split(',').map((item) => item.trim());
};
